/**
 * Adapted from reporting_app/web/src/hooks/usePagePermissions.ts: reads off
 * AuthContext's already-fetched `user.accessiblePages` — no separate
 * network call.
 */
import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';

export interface PagePermission {
  canView: boolean;
  canEdit: boolean;
}

export function usePagePermissions(pageUrl: string): PagePermission & { isLoading: boolean } {
  const { user, loading } = useAuth();
  return useMemo(() => {
    if (loading || !user) return { canView: false, canEdit: false, isLoading: loading };
    const page = user.accessiblePages.find(p => p.pageUrl === pageUrl);
    return { canView: page?.canView ?? false, canEdit: page?.canEdit ?? false, isLoading: false };
  }, [user, pageUrl, loading]);
}
